import { configure } from './http';

let currentAuthToken: string | null = null;

export const setFiscalpopApiAuthToken = (token: string | null) => {
    currentAuthToken = token;
};

configure({ getAuthToken: () => currentAuthToken });
